import * as React from "react";

import { AppSelect } from "components/AppSelect";
import { AppModalHeader } from "components/AppModal/AppModalHeader";
import { AppButton } from "components/AppButton";

import { PayoutUserType } from "models/payout";

import styles from "./AttractorDetails.module.scss";
import { getFio } from "helpers/formatText";
import { usePagination } from "hooks/usePagination";
import { PayoutApi } from "services/api/PayoutApi";

interface Props {
  user: PayoutUserType;
  disabled: boolean;
  onClose?(): void;
  onSwap: (id: number) => void;
}

export const AttractorDetails: React.FC<Props> = ({
  user,
  disabled,
  onClose,
  onSwap,
}) => {
  const { list } = usePagination(PayoutApi.getCalcs)
  const [selectedId, setSelectedId] = React.useState<number | null>(null)

  const _onSwap = () => {
    if (selectedId) {
      onSwap(selectedId)
    }
  }

  const calcsOptions = list.map((item) => ({
    title: item.plan.name,
    value: item.id,
  }));

  const selectedCalc = selectedId ? list.find(item => item.id === selectedId) : null

  return (
    <>
      <div className={styles.container}>
        <AppModalHeader onClose={onClose} title={`
          ${getFio(user)}
          \n
          ${user.phone}
        `} />
        <div className={styles.content}>
          <AppSelect
            text={
              calcsOptions.find((item) => item.value === selectedId)
                ?.title
            }
            onChangeValues={([value = ""]) =>
              setSelectedId(value)
            }
            list={calcsOptions.filter(item => item.value !== selectedId)}
          />

          <AppButton
            disabled={!selectedId || disabled}
            onClick={_onSwap}
            size="small"
            variant="siren"
          >
            Сохранить
          </AppButton>

          {selectedCalc?.plan?.values?.length ? (
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Количество</th>
                  <th>Сумма</th>
                </tr>
              </thead>
              <tbody>
                {selectedCalc?.plan.values.map(value => (
                  <tr key={value.id}>
                    <td>{value.count}</td>
                    <td>{value.sum}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : null}
        </div>
      </div>
    </>
  );
};